<section>
    <article class="card container-fluid">
        <h2 class="card-header text-center font-weight-bold text-uppercase py-4">Your Properties</h2>
        <article class="table-header">

          <!-- Toolbar -->
          <div class="toolbar">
              <!-- Upload Properties -->
              <button type="button" class="dt-button" (click)="uploadPropertiesDialog()">
                <span>Upload Properties</span>
                <mdb-icon class="text-info ml-1" fas icon="cloud-upload-alt" size="md"></mdb-icon>
              </button>

              <!-- Add Property -->
              <button type="button" class="dt-button" (click)="addPropertyDialog()">
                <span>Add Property</span>
                <mdb-icon class="text-success ml-1" fas icon="plus" size="md"></mdb-icon>
              </button>
            </div>
        </article>
        <div class="card-body" style="overflow-x:auto;">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>Entry Date</th>
                        <th>For Rent</th>
                        <th>Owner Name</th>
                        <th>Manager Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>Zip Code</th>
                        <th>Building #</th>
                        <th>Building Units</th>
                        <th>Avail Units</th>
                        <th>Property Note</th>
                        <th>Housing Vouchers Acceptance</th>
                        <th>Voucher Note</th>
                        <th>Building ADA Accessible</th>
                        <th>Unit ADA Accessible</th>
                        <th>Accessible Note</th>
                        <th>Incentive for Rentwise</th>
                        <th>Incentive Note</th>
                        <th>Edit/Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let property of properties">
                        <td class="text-nowrap" [attr.data-sort]="sortDate(property.entryDate)">{{ property.entryDate | date }}</td>
                        <td>
                          <mat-slide-toggle aria-label="toggle property for rent" color="primary" [disabled]="property.saving"
                              [(ngModel)]="property.isAvailable" [ngModelOptions]="{ standalone: true }" (change)="saveAvailability(property)">
                            {{ property.isAvailable | boolean:'Yes':'No' }}
                          </mat-slide-toggle>
                        </td>
                        <td>{{ property.ownerName }}</td>
                        <td>{{ property.managerName }}</td>
                        <td>{{ property.contactPhone }}</td>
                        <td>{{ property.email }}</td>
                        <td>{{ property.address }}</td>
                        <td>{{ property.city }}</td>
                        <td>{{ property.zipCode }}</td>
                        <td>{{ property.buildingNumber ? property.buildingNumber : 1 }}</td>
                        <td>{{ property.buildingUnits ? property.buildingUnits : 1 }}</td>
                        <td>{{ property.availableUnits ? property.availableUnits : 0 }}</td>
                        <td>{{ property.propertyNote }}</td>
                        <td>{{ property.hcvCheck | boolean:'Yes':'No' }}</td>
                        <td>{{ property.hcvNote }}</td>
                        <td>{{ property.buildingAdaAccessible | boolean:'Yes':'No' }}</td>
                        <td>{{ property.unitAdaAccessible | boolean:'Yes':'No' }}</td>
                        <td>{{ property.accessibleNote }}</td>
                        <td>{{ property.incentiveForRentwise | boolean:'Yes':'No' }}</td>
                        <td>{{ property.incentiveNote }}</td>
                        <td>
                            <button type="button" (click)="editProperty(property)"><mdb-icon fas icon="pen"></mdb-icon></button>
                            <button type="button" (click)="deleteProperty(property)" class="ml-2 btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</section>
